import { CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Injectable, Injector, inject } from '@angular/core';
import { UserService } from '../services';
import { map } from 'rxjs/operators';
import { awaitUserLookup } from './await-user-lookup';

@Injectable()
export class DashboardGuard implements CanActivate {
  private readonly injector = inject(Injector);

  constructor(private authService: AuthService, private userService: UserService) { }

  public canActivate() {
    return this.checkAuthToken();
  }

  public canLoad() {
    return this.checkAuthToken();
  }

  public checkAuthToken() {
    if (this.authService.getAuthToken() === '') {
      this.authService.login();
    }

    return awaitUserLookup(this.userService, this.injector).pipe(map(({ user }) => !!user));
  }
}

